module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-expand-transition', [(_vm.isVisible) ? _c('div', [(!_vm.schema._root || !_vm.schema._root.readOnly || _vm.schema.type == 'Group' || _vm.schema.type == 'Section Heading') ? _c(_vm.controlName, {
    tag: "component",
    attrs: {
      "schema": _vm.mergedSchema,
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  }) : [(_vm.schema.type == 'File') ? _c('FileView', {
    attrs: {
      "schema": _vm.mergedSchema,
      "value": _vm.value
    }
  }) : _c('div', [(_vm.value) ? [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("\n                        " + _vm._s(_vm.mergedSchema.label) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  })] : _vm._e()], 2)]], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59de637e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/DynamicControl.vue
// module id = 2563
// module chunks = 1